import { AuditAudioAlt } from '@mi-front/core';
import { BtnLink } from '@mi-front/ui';
import { useIntl } from 'react-intl';

interface Props {
  audio: AuditAudioAlt;
  url: string;
}

export function MatchLink(p: Props) {
  const { $t } = useIntl();

  return (
    <div>
      <span className="font-size-sm">
        {$t({
          id: 'audit.reportsScreen.noMatches.sameAudioMatch.message',
          defaultMessage: 'Hay un material con el mismo contenido que tiene matches:',
        })}{' '}
        <strong>{p.audio.customId}</strong>
      </span>

      <div className="mt-2">
        <BtnLink size="xs" to={p.url} target="_blank">
          {$t(
            {
              id: 'audit.reportsScreen.noMatches.sameAudioMatch.matchesLink',
              defaultMessage: 'Ver matches de {audioId}',
            },
            {
              audioId: p.audio.customId,
            },
          )}
        </BtnLink>
      </div>
    </div>
  );
}
